export default {
  brand: {
    name: 'Global Data',
    description: '상하이 Global Data는 혁신 기술로 기업의 디지털 전환을 지원하고 더 스마트한 미래를 함께 만들어 갑니다.'
  },
  quickLinks: {
    title: '바로가기',
    home: '홈',
    about: '회사 소개',
    coreService: '핵심 서비스',
    industrySolutions: '산업별 솔루션',
    caseStudies: '사례 소개',
    resourceCenter: '리소스 센터',
    customerSupport: '고객 지원',
    contact: '문의하기'
  },
  solutions: {
    title: '산업별 솔루션',
    finance: '금융',
    ticketAI: '티켓 AI 어시스턴트',
    manufacturing: '제조',
    healthcare: '헬스케어',
    government: '정부 및 공공 부문'
  },
  contactInfo: {
    title: '연락처 정보',
    address: '중국 상하이시 징안구 시짱베이로 199호 광밍부동산빌딩 1003-1실'
  },
  copyright: '© 2023 Shanghai Sidong Technology Co., Ltd. All rights reserved.'
}
